import AspectWrapper from "core-web/components/AspectWrapper";
import styled from "theme/libs/styled";

const Div = styled("div")`
    width: 100%;
    height: 100%;
`;

const ProductPageTopRight = () => {
    return (
        <AspectWrapper ratio={1}>
            <Div />
        </AspectWrapper>
    );
};

export default ProductPageTopRight;
